import { useRefreshTokenQuery } from '../api';
import { useAuth } from './useAuth';

export const useRefreshToken = () => {
    const { isAuthenticated } = useAuth();
    const refreshTokenResult = useRefreshTokenQuery(undefined, {
        skip: Boolean(isAuthenticated),
    });

    return {
        ...refreshTokenResult,
    };
};
